/* eslint-disable func-names */
import React from 'react';

export default function () {
    return <div className="divider tw-border-1 tw-border-opacity-50 tw-border-solid tw-border-grey-3" />;
}
